export const getPageCount = (totalCount: number, limit: number) => Math.ceil(totalCount / limit)
